
export default function ServiceProcess() {
  const steps = [
    {
      number: '01',
      title: 'お問い合わせ',
      description: 'お電話またはお問い合わせフォームからご連絡ください。ご要望やご予算について詳しくお聞かせください。',
      icon: 'ri-phone-line'
    },
    {
      number: '02',
      title: '現地調査・ヒアリング',
      description: '専門スタッフがお伺いし、現地調査を実施。お客様のご要望を詳しくお聞きし、最適なプランを検討いたします。',
      icon: 'ri-search-line'
    },
    {
      number: '03',
      title: 'お見積もり・プラン提案',
      description: '調査結果をもとに詳細なお見積もりとプランをご提案。ご納得いただけるまで何度でも修正いたします。',
      icon: 'ri-file-text-line'
    },
    {
      number: '04',
      title: 'ご契約',
      description: 'プラン・お見積もりにご納得いただけましたら、正式にご契約となります。工事スケジュールを調整いたします。',
      icon: 'ri-contract-line'
    },
    {
      number: '05',
      title: '工事開始',
      description: '経験豊富な職人が丁寧に工事を進めます。工事期間中も定期的に進捗をご報告いたします。',
      icon: 'ri-hammer-line'
    },
    {
      number: '06',
      title: '完成・お引き渡し',
      description: '工事完了後、お客様と一緒に最終確認を行い、ご満足いただけましたらお引き渡しとなります。',
      icon: 'ri-home-smile-line'
    }
  ];

  return (
    <section className="py-12 sm:py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-8 sm:mb-12 md:mb-16">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-3 sm:mb-4">
            <strong>工事の流れ</strong>
          </h2>
          <p className="text-sm sm:text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            お問い合わせから完成まで、お客様に安心していただける丁寧なサポートを心がけています
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="bg-white rounded-lg p-5 sm:p-6 shadow-lg hover:shadow-xl transition-shadow h-full">
                <div className="flex items-center mb-3 sm:mb-4">
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-600 text-white rounded-full flex items-center justify-center font-bold text-base sm:text-lg mr-3 sm:mr-4 flex-shrink-0">
                    {step.number}
                  </div>
                  <div className="w-10 h-10 sm:w-12 sm:h-12 bg-teal-100 rounded-lg flex items-center justify-center flex-shrink-0">
                    <i className={`${step.icon} text-xl sm:text-2xl text-teal-600`}></i>
                  </div>
                </div>
                
                <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-2 sm:mb-3">{step.title}</h3>
                <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{step.description}</p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <i className="ri-arrow-right-line text-2xl text-teal-300"></i>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-8 sm:mt-12 text-center">
          <div className="bg-teal-50 rounded-lg p-6 sm:p-8 max-w-4xl mx-auto">
            <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">
              <strong>無料見積もり・現地調査実施中</strong>
            </h3>
            <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6 px-4">
              お見積もりや現地調査は無料で承っております。まずはお気軽にご相談ください。岡山県内全域対応可能です。
            </p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <a 
                href="tel:086-012-3456"
                className="bg-teal-600 text-white px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap cursor-pointer flex items-center justify-center"
              >
                <i className="ri-phone-line mr-2"></i>
                086-012-3456
              </a>
              <a 
                href="/#contact"
                className="bg-white text-teal-600 border-2 border-teal-600 px-6 sm:px-8 py-2.5 sm:py-3 rounded-lg text-sm sm:text-base font-semibold hover:bg-teal-50 transition-colors whitespace-nowrap cursor-pointer"
              >
                お問い合わせフォーム
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
